import React, { FunctionComponent } from "react";
import "./styles.scss";
import { PanelWrapper } from "../PanelWrapper";

export interface IProps {
  styleOverride?: { [key: string]: string | number };
  children: JSX.Element | JSX.Element[];
}

export const AuthorBylineSection: FunctionComponent<IProps> = ({
  styleOverride,
  children,
}) => (
  <PanelWrapper className="author-byline_section__wrapper">
    <section className="author-byline_section" style={styleOverride}>
      {children}
    </section>
  </PanelWrapper>
);
